import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { SysConfig } from "__SYSDefault/Config";
import PAMaidManageM from "./PAMaidManageM";
import PAMaidManageW from "./PAMaidManageW";

/**
 * @augments {Component<Props, State>}
 */
class PAMaidManage extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAMaidManage.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <PAMaidManageM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <PAMaidManageW {...this.props} />,
    });
  }

}

export default observer(PAMaidManage);
